define("ember-intl/macros/index", ["exports", "ember-intl/macros/intl", "ember-intl/macros/t"], function (_exports, _intl, _t) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  Object.defineProperty(_exports, "intl", {
    enumerable: true,
    get: function () {
      return _intl.default;
    }
  });
  Object.defineProperty(_exports, "raw", {
    enumerable: true,
    get: function () {
      return _t.raw;
    }
  });
  Object.defineProperty(_exports, "t", {
    enumerable: true,
    get: function () {
      return _t.default;
    }
  });
});